import { cancelAServiceDataEn } from "constants-lib/seo/faqDataImplementation"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getcancelAServiceEn = () => {
  const data = cancelAServiceDataEn.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addcancelAService = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/how-do-i-cancel-a-service`,
    ) &&
    document.getElementById(`cancelAServiceJSONLD`) === null
  ) {
    const script = cancelAServiceJSONLDEn()
    addJSONLDToHead(script, `cancelAServiceJSONLD`)
  } else {
    removeElement(`cancelAServiceJSONLD`)
  }
}

// JSON LD template for FAQ Bagster
const cancelAServiceJSONLDEn = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getcancelAServiceEn(),
  }
  return FaqBagsterTemplate
}
